// Home.js
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import 'animate.css';
import './styles.css';

const Home = () => {
  const navigate = useNavigate();

  // Refs for the elements to animate
  const headingRef = useRef(null);
  const paraRef = useRef(null);
  const footerRef = useRef(null);

  useEffect(() => {
    const elements = [headingRef.current, paraRef.current, footerRef.current];

    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate__slideInDown');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1,
    });

    elements.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      elements.forEach((el) => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  return (
    <div className="duino">
      <div className="para_container">
        <div className="button_section">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwhhDo0NZ9iWcEgTHVMjJWGnWIOunvh-a0Pg&s"
            alt="uom_logo"
            width="170"
            height="200"
          />
          <h1>Server Room Monitoring System</h1>
          <p id="dinith">By Duinobots</p>
          <div className="buttons">
            <button onClick={() => navigate('/signup')} className="SignUp_Home">
              Sign Up
            </button>
            <button onClick={() => navigate('/login')} className="Login_Home">
              Log In
            </button>
          </div>
        </div>
      </div>

      {/* Scroll-triggered animated section */}
      <h1 id="text" ref={headingRef} className="animate__animated">
        About Server Room Monitoring System
      </h1>

      <div className="para_container">
        <div ref={paraRef} className="para animate__animated">
          <p>
            This system is an ESP32 microcontroller-based system designed to automate AC units,
            measure temperature, humidity, VOC concentration, check UPS status, and monitor server
            status. It also includes a fire alarm system and an immediate SMS alert system.
          </p>
        </div>
      </div>

      <footer>
        <hr />
        <p ref={footerRef} className="copy animate__animated">
          &copy; All Rights Reserved By Duinobots
        </p>
      </footer>
    </div>
  );
};

export default Home;
